import { styled } from '@mui/material'
import React from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'

/**
 * Custom styled NavLink component using MUI's styled API.
 */
const StyledNavLink = styled(NavLink)(() => ({
  textDecoration: 'none'
}))

/**
 * Props for the NavLink component.
 */
interface INavLinkBaseProps extends NavLinkProps {
  /** If true, the link will be absolute (starts with a slash) (optional) */
  absolute?: boolean
}

/**
 * NavLink component with custom styles
 * This component is styled using MUI's styled API.
 * @param {INavLinkBaseProps} props - The properties for the NavLink component.
 * @returns {JSX.Element} Returns a NavLink component.
 */
const NavLinkBase: React.FC<INavLinkBaseProps> = ({ absolute, ...props }) => {
  return <StyledNavLink {...props} to={absolute ? `/${props.to}` : props.to} />
}

export default NavLinkBase
